/**
 * Layouts - Shell entry points
 * Each layout defines the structure of a screen region
 */

export { BlankComponent } from './blank';
export { FullComponent } from './full';
